import AddToHomeScreen from '@mui/icons-material/SystemUpdate';

import React from 'react';

import NotificationActionButtons from './NotificationActionButtons';
import injectStores from '../RootStore/injectStores';
import type ViewStore from 'stores/ViewStore';

interface NotificationButtonInstallPwaProps {
  viewStore?: ViewStore;
}

const NotificationButtonInstallPwa = injectStores(
  ({ viewStore }: NotificationButtonInstallPwaProps) => {
    return (
      <NotificationActionButtons
        onClick={(key) => viewStore?.handleInstallAccepted(key)}
        actionColor="info"
        close
      >
        <AddToHomeScreen />
      </NotificationActionButtons>
    );
  }
);

export default NotificationButtonInstallPwa;
